import {gql} from 'apollo-angular';

export const GET_ROOKIE_PROVIDER_REGISTER_TIME = gql`
  query RookieProviderRegisterTime($districtId: Int!) {
    rookieProviderRegisterTime(districtId: $districtId) {
      openAt
      closeAt
    }
  }
`;
